import React from 'react'
import { useAppDispatch } from '../../../hooks/redux'

import BigFolderFaceIcon from '../../../components/icons/BigFolderFaceIcon'
import Button2 from '../../../components/atoms/Button2'
import ArticleBreadcrumbs from '../../../components/atoms/ArticleBreadcrumbs'

import { useBreakpoint } from '../../../providers/BreakpointProvider'
import { setCreating } from '../../../slices/article'
import useStyles from './styles'

const NoDocuments = ({ onSubFolder = false }) => {
  const { isSmall } = useBreakpoint()

  const dispatch = useAppDispatch()

  const classes = useStyles({ isSmall })

  const handleDocumentCreateClick = React.useCallback(() => {
    dispatch(setCreating(true))
  }, [dispatch])

  if (onSubFolder) {
    return (
      <div className={classes.noDocumentRoot}>
        <div className={classes.breadcrumbsContainer}>
          {onSubFolder && <ArticleBreadcrumbs className={classes.crumbs} />}
        </div>
        <div className={classes.noDocumentContainer}>
          <BigFolderFaceIcon className={classes.icon} />

          <div className={classes.title}>
            You don't have any articles created yet
          </div>

          <div className={classes.subtitle}>
            Let's get started. Create and organize articles.
          </div>

          <div className={classes.buttonBar}>
            <Button2 onClick={handleDocumentCreateClick}>+ New Article</Button2>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      {onSubFolder && <ArticleBreadcrumbs className={classes.crumbs} />}

      <BigFolderFaceIcon className={classes.icon} />

      <div className={classes.title}>
        You don't have any folders or articles created yet
      </div>

      <div className={classes.subtitle}>
        Let's get started. You can create and organize articles in a folder.
      </div>

      <div className={classes.buttonBar}>
        <Button2>+ New Folder</Button2>

        <Button2 onClick={handleDocumentCreateClick}>+ New Document</Button2>
      </div>
    </div>
  )
}

export default NoDocuments
